type Runtime = {
    isProd: boolean;
    build: string;
};

const hash = VITE_CACHE_KEY;

export function getRuntime(): Runtime {
    const prod = process.env.NODE_ENV === 'production';
    const moduleUrl = new URL(import.meta.url);

    // To support hotreload in development mode
    const build = moduleUrl.searchParams.get('t') || hash;
    return {
        isProd: prod,
        build,
    };
}
